/**
 * Simple querystring encoder.
 * @param {*} args
 */
export const queryStringEncode = args =>
  Object.keys(args)
    .map(k => ({ v: args[k], k }))
    .filter(({ v }) => v)
    .map(({ k, v }) => encodeURIComponent(k) + '=' + encodeURIComponent(v))
    .join('&')
